export default __webpack_public_path__ + "static/media/element_49.7786c72a.webp";